export default {
  SET_ARN_ACTIVE_TAB(state, payload) {
    state.arnActiveTab = payload
  },
}
